var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.isOk)?_c('Login',{attrs:{"type":1,"onSuccess":_vm.handleSuccess}}):_c('div',[_c('ProductList',{attrs:{"plan-id":_vm.planId}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }